import styled from 'styled-components';

export const PasswordStrengthBox = styled.div`
margin-top: 1rem;

.strength-meter {
  height: 10px;

  &#strength-meter-container {
    background-color: var(--color-border-muted);
  }

  &#strength-meter-gauge {
    &.weak {
      width: 15%;
      background-color: var(--color-feedback-border-input-error);
    }

    &.okay {
      width: 40%;
      background-color: var(--color-feedback-border-input-warning);
    }

    &.good {
      width: 70%;
      background-color: var(--color-feedback-border-input-success);
    }

    &.great {
      width: 100%;
      background-color: var(--color-feedback-border-input-success);
    }

    &.strength {
      width: 0%;
    }
  }
}

.strength-text {
  margin-top: 4px;
  color: var(--color-text-secondary);

  &.weak {
    color: var(--color-feedback-border-input-error);
  }

  &.okay {
    color: var(--color-text-secondary);
  }

  &.good {
    color: var(--color-feedback-border-input-success);
  }

  &.great {
    color: var(--color-feedback-border-input-success);
  }

  &.strength {
    color: transparent;
  }
`;
